import type { FileTreeProps } from './FileTree.types';
import { DirectoryType } from '@/_types/models/documents';
import { DocumentsContext } from '@/_contexts/DocumentsProvider';
import { FileItem } from './components/FileItem';
import { getClasses } from '@/_utils/classnames';
import { getFileItemPath } from '@/_utils/documents';
import { useContext, type FC } from 'react';

export const FileTree: FC<FileTreeProps> = ({ documentItem }) => {
  const { openDirectory } = useContext(DocumentsContext);
  const realPath = getFileItemPath(documentItem.link);

  const isInPath: boolean = openDirectory.startsWith(realPath);
  const hasChildren: boolean = !!(documentItem as DirectoryType)?.children
    ?.length;
  const isOpen: boolean = isInPath || hasChildren;

  const fileTreeClasses: string = getClasses('flex flex-column gap-2');

  return (
    <li className={fileTreeClasses}>
      <FileItem item={documentItem as DirectoryType} />
      {isOpen && (documentItem as DirectoryType).children?.length > 0 && (
        <ol style={{ marginLeft: '20px' }}>
          {(documentItem as DirectoryType).children?.map((fItem, key) => (
            <FileTree key={key} documentItem={fItem} />
          ))}
        </ol>
      )}
    </li>
  );
};
